import { render, staticRenderFns } from "./TechChatSection.vue?vue&type=template&id=dc4c0830"
import script from "./TechChatSection.vue?vue&type=script&lang=js"
export * from "./TechChatSection.vue?vue&type=script&lang=js"
import style0 from "./TechChatSection.vue?vue&type=style&index=0&id=dc4c0830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports